<template>
  <div id="app" class="test-page">
    <HeadNav selectedLanguage="en" page="test" />

    <main class="test-main">
      <section class="test-panel">
        <h1>Instagram Parser Test</h1>

        <div class="test-actions">
          <button type="button" :disabled="loading" @click="loadStatus">
            {{ loading ? 'Checking...' : 'Check Status' }}
          </button>
        </div>

        <p v-if="error" class="test-error">{{ error }}</p>
        <pre v-if="status" class="test-output">{{ formattedStatus }}</pre>
      </section>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
import HeadNav from '@/components/HeadNav.vue';
import '@/css/base.scss';
import '@/css/index.scss';

export default {
  name: 'TestPage',
  components: {
    HeadNav,
  },
  data() {
    return {
      loading: false,
      error: '',
      status: null,
    };
  },
  computed: {
    formattedStatus() {
      return JSON.stringify(this.status, null, 2);
    },
  },
  mounted() {
    this.loadStatus();
  },
  methods: {
    async loadStatus() {
      this.loading = true;
      this.error = '';

      try {
        const res = await axios.get('/api/instagram/test');
        this.status = res.data;
      } catch (error) {
        this.error =
          (error.response && error.response.data && error.response.data.message) ||
          error.message ||
          'Status check failed.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.test-page {
  min-height: 100vh;
  background: #eef2f7;
}

.test-main {
  max-width: 960px;
  margin: 0 auto;
  padding: 56px 24px;
}

.test-panel {
  background: #fff;
  border: 1px solid #d8dee8;
  border-radius: 8px;
  padding: 32px;
}

.test-panel h1 {
  margin: 0 0 24px;
  color: #102a43;
  font-size: 28px;
}

.test-actions {
  margin-bottom: 20px;
}

.test-actions button {
  min-width: 140px;
  height: 44px;
  border: 0;
  border-radius: 6px;
  background: #087ee8;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

.test-actions button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.test-error {
  padding: 14px 16px;
  border: 1px solid #f43f5e;
  border-radius: 6px;
  color: #be123c;
  background: #fff1f2;
}

.test-output {
  overflow-x: auto;
  margin: 0;
  padding: 18px;
  border-radius: 6px;
  background: #0f172a;
  color: #e2e8f0;
  font-size: 14px;
  line-height: 1.6;
}
</style>
